module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagez"
  }, [_c('a', {
    attrs: {
      "id": "ch01"
    }
  }), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/ch01.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('h2', {
    staticClass: "h2"
  }, [_vm._v("Lost Gummy Flavors")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "stickup"
  }, [_vm._v("R")]), _vm._v("aina the Gummy Fairy licked her lips. She was looking at a ripe orange gummy tulip. The flower was the most delicious color and shape. "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("“Sweet-tacular!”")]), _vm._v(" she exclaimed.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Her basket was overflowing with freshly picked gummy flowers. “It’s been a good season for these,” she said to Blue Belle, her ")]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("gummy bear friend. The bear nodded. Raina took good care of many animals in Gummy Forest. “Let’s both have one,” she said with a smile. The burst of orange flavor in her mouth made her grin.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“Hi, Raina!” Berry the Fruit Fairy called from above. “Hey, Blue Belle!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Berry!” Raina called. “You have to try these gummy tulips!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Berry landed next to Raina. She was dressed in a beautiful purple-and-pink dress. Berry always dressed her best. She had all the fashion sense that Raina didn’t have! No one could whip up an outfit like Berry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Raina handed her a grape-flavored gummy tulip.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("“Mmm, this "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("is")]), _vm._v(" delicious,” Berry said. “What ")]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("a great harvest! You should give some of these to Princess Lolli and Prince Scoop.”")])]), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Raina had already given a bouquet to the ruling fairy princess and her husband. She loved visiting Princess Lolli and Prince Scoop at Candy Castle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I dropped off a basket of flowers for them yesterday,” Raina told her. She reached into her bag. “Prince Scoop gave me this.” She showed Berry a beautiful book with gold trim.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Sweet sugars!” Berry exclaimed. “What is the book about?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“The book is called "), _c('span', {
    staticClass: "txit"
  }, [_vm._v("Tropical Treasures")]), _vm._v(" and tells the flavor history of the Ice Cream Isles,” Raina told her. “I was asking Prince Scoop about the different flavors of ice cream we ate at the Ice Cream Festival.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c62556b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch01.vue
// module id = 66
// module chunks = 0